export default {
  FAQ_PAGE_HEADING: `Preguntas frecuentes (FAQ) y solución de problemas`,
  COLLAPSE_FAQ_LABEL_TEXT: `Contraer FAQ`,
  EXPAND_FAQ_LABEL_TEXT: `Ampliar FAQ`,
  FAQ_SPEAKERS_HEADING: `Solucionar problemas con tus altavoces`,
  FAQ_MICROPHONE_HEADING: `Solucionar problemas con tu micrófono`,
  FAQ_CAMERA_HEADING: `Solucionar problemas con tu cámara`,
  FAQ_STILL_HAVE_QUESTIONS: `¿Todavía tienes preguntas? Comunícate con tu consultorio.`,

  WHAT_IS_A_TELEHEALTH_APPT_HEADING: `¿Qué es una cita de telesalud?`,
  WHAT_IS_A_TELEHEALTH_APPT_CONTENT: `
    <p>
      Una cita de telesalud es un video en línea o una llamada telefónica con tu proveedor para determinar tus
      necesidades de atención médica y los pasos a seguir. Las citas en línea te permiten hablar con tu proveedor
      sin necesidad de salir de tu casa.
    </p>
    <p>
      Son convenientes, ahorran tiempo y ayudan a mantener seguros a los pacientes y al personal durante una crisis
      (como un desastre natural o una pandemia). Las visitas de telesalud pueden cubrir una amplia gama de necesidades:
      salud mental, seguimientos por enfermedades crónicas, erupciones y más.
    </p>
    <p>
      Para tener una cita de telesalud, necesitas un teléfono inteligente, tableta o computadora. Debe tener acceso a
      Internet y video. Esto puede ser una cámara y un micrófono incorporado o tener un equipo separado conectado.
    </p>`,

  HOW_DO_I_PREPARE_HEADING: `¿Cómo me preparo para mi cita?`,
  HOW_DO_I_PREPARE_CONTENT: `
    <p>Prepara tu equipo antes de tu cita:</p>
    <p>Asegúrate de que tu computadora, tableta o teléfono inteligente tenga todo lo siguiente:</p>
    <2>
      <0>Una conexión de Internet</0>
      <1>Una cámara y micrófono</1>
      <2>Uno de los navegadores compatibles con athenaTelehealth (enumerados debajo)</2>
      <3>Confirma que todo está configurado:</3>
      <4>
        <0>Asegúrate de que funcionen la cámara, el micrófono y los altavoces (utiliza nuestro rápido chequeo <2>del dispositivo previo a la llamada</2>).</0>
        <1>Cierra las aplicaciones que no estés usando para liberar ancho de banda y memoria a fin de obtener una mejor calidad de llamada.</1>
      </4>
      <5>Encuentra el mejor lugar para realizar tu llamada:</5>
      <6>
        <0>Encuentra un lugar tranquilo, donde te sientas bien para hablar sobre tus preocupaciones con el proveedor.</0>
        <1>Enciende las luces de la habitación o siéntate cerca de una ventana para que tu proveedor pueda verte con claridad. </1>
        <2>Si estás usando un equipo móvil, asegúrate de enfocar tu cámara hacia ti. Sostén el teléfono a la altura de los ojos durante la llamada. También puedes colocar el teléfono en algún lugar para tener las manos libres.</2>
      </6>
    </2>
    <p>También debes tener a mano:</p>
    <4>
      <0>Tu información de seguro actualizada</0>
      <1>Una forma de pago</1>
      <2>Cualquier pregunta para tu proveedor</2>
      <3>Tu lista actual de medicamentos (incluso puedes sacar los frascos y tenerlos al alcance)</3>
    </4>
    <p>Planea unirte a la llamada de tu cita 5-10 minutos antes de la hora programada para verificar la conexión y asegurarte de que todo esté listo para el momento en que tu proveedor se una.</p>`,

  WHICH_BROWSERS_CAN_I_USE_HEADING: `¿Qué navegador puedo usar para mi cita?`,
  WHICH_BROWSERS_CAN_I_USE_CONTENT: `
    <p>Estos son los navegadores compatibles con la aplicación athenaTelehealth:</p>
    <1>
      <0>Escritorio</0>
    </1>
    <2>
      <0>Google Chrome (las últimas 3 versiones) para macOS y Windows</0>
      <1>Safari (versión 12 y superior) para macOS</1>
      <2>Firefox (últimas tres versiones) para macOS y Windows</2>
    </2>
    <3>
      <0>Mobile</0>
    </3>
    <4>
      <0>Google Chrome (las últimas 3 versiones) para Android</0>
      <1>Samsung Browser (versión 12 y posterior) para Android</1>
      <2>Google Chrome (las últimas 3 versiones) para iOS</2>
      <3>Safari (versión 12 y posterior) para iOS (Importante: athenaTelehealth no es compatible con otros
        navegadores iOS, como es el caso de Firefox)</3>
    </4>`,

  INTERNET_SPEED_HEADING: `¿Mi velocidad de Internet afectará la calidad de mi llamada? ¿Qué puedo hacer para mejorarla?`,
  INTERNET_SPEED_CONTENT: `
    <p>
      La velocidad de Internet puede afectar la calidad general de las llamadas. Sin embargo, podrás tomar
      algunas medidas para asegurarte de tener el mayor acceso posible a Internet durante la llamada:
    </p>
    <1>
      <0>Cierra cualquier otra app en tu dispositivo. Cierra otras pestañas y ventanas del navegador.</0>
      <1>
        <0>Esto podría estar ocupando el ancho de banda de Internet y la memoria de tu dispositivo.</0>
        <1>Esto incluye aplicaciones no utilizadas, aplicaciones de fondo y aplicaciones de transmisión
          como Netflix o YouTube.</1>
      </1>
      <2>Desactiva el modo de bajo consumo en dispositivos con batería. Pon a cargar el dispositivo
        para salir del modo de bajo consumo.</2>
      <3>
        <0>El modo de bajo consumo puede desactivar algunas funciones de tu dispositivo y reducir su
          rendimiento, lo cual podría afectar tu llamada.</0>
      </3>
      <4>
        Si otras personas también están usando Internet en tu casa, verifica si pueden dejar de
        hacerlo mientras realizas la llamada.
      </4>
    </1>
    <p>También puedes tratar de contactar a tu proveedor de servicios de Internet.</p>
    <3>
      <0>
        Es posible que puedan ayudarte a solucionar tus problemas. También podrían tener
        diferentes opciones para obtener conexiones más rápidas.
      </0>
      <1>
        Debido al COVID-19, algunas compañías de Internet están ralentizando intencionalmente
        el tráfico de Internet durante las horas de alta demanda. Eso ayudará con los problemas
        de conexión mientras muchas personas están haciendo streaming de videos en casa. Si crees
        que esto te está pasando, solicita a tu proveedor de Internet que permita el tráfico normal
        a Athena.io porque lo estás usando para obtener atención médica.
      </1>
    </3>`,

  WHERE_IS_MY_LINK_HEADING: `¿Dónde está el enlace de mi cita?`,
  WHERE_IS_MY_LINK_CONTENT: `
    <p>
      El enlace de tu cita estará en los correos electrónicos que te envíe tu consultorio (para confirmar y recordarte tu
      cita).  En el mensaje de correo electrónico, haz clic en el botón azul que dice "TU ENLACE DE CITA" O "IR A LA CITA".
      Si no puedes encontrar estos correos electrónicos, revisa tus carpetas de correo electrónico "no deseados" o "basura".
    </p>
    <p>Tu consultorio también te enviará un mensaje de texto con el enlace como recordatorio.</p>
    <p>Si no puedes encontrar el enlace, puedes solicitar al consultorio que te lo envíe nuevamente.</p><p> Asegúrate de que tu consultorio tenga tus datos de contacto actualizados, incluyendo la dirección de correo electrónico y el número de teléfono.  Si utilizas un sitio web del portal del paciente para contactar a tu consultorio, asegúrate de que tu correo electrónico y número de teléfono se actualicen allí también. </p>`,

  WHEN_SHOULD_I_JOIN_HEADING: `¿Cuándo debo unirme a mi llamada?`,
  WHEN_SHOULD_I_JOIN_CONTENT: `
    <p>
      Únete a tu llamada de 5 a 10 minutos antes de la hora programada para verificar tu conexión y
      asegurarte de que todo esté listo para cuando tu proveedor se una a la llamada.
    </p>
    <p>
      El enlace solo funcionará el día de tu cita.  Si quieres probar el enlace, puedes hacerlo
      el mismo día de tu cita.
    </p>
    <p>
      Cada cita tendrá su propio enlace por separado, incluso si tienes más de una cita el mismo
      día.  Asegúrate de usar el enlace correcto para la cita correspondiente.
    </p>`,

  WHAT_SHOULD_I_DO_WHEN_JOIN_HEADING: `¿Qué debo hacer cuando me uno a la llamada?`,
  WHAT_SHOULD_I_DO_WHEN_JOIN_CONTENT: `
    <p>
      Cuando te unas a la llamada, estarás en una "sala de espera" virtual privada.  Por favor, espera hasta que se una
      un miembro de tu equipo de atención.
    </p>
    <p>
      No comiences a usar otras aplicaciones que requieran de la cámara, el micrófono o los altavoces.  Eso podría impedir
      que escuches cuando se una alguien más.
    </p>
    <p>
      El calendario de tu proveedor puede ser muy impredecible en estos días, así que te agradecemos tu paciencia mientras
      esperas.
    </p>`,

  IS_MY_CALL_SECURE_HEADING: `¿Mi llamada de athenaTelehealth es confidencial y segura?`,
  IS_MY_CALL_SECURE_CONTENT: `
    <p>
      Sí, las llamadas de athenaTelehealth son confidenciales y seguras.  La aplicación
      cumple con HIPAA.
    </p>
    <p>
      Cada cita en línea tiene un enlace único. Los enlaces nunca se reutilizan ni copian,
      y nunca están disponibles para nadie más.
    </p>`,

  WHY_CANT_SEE_SELF_HEADING: `¿Por qué no puedo verme?`,
  WHY_CANT_SEE_SELF_CONTENT: `
    <p>
      Otra aplicación puede estar utilizando tu cámara. Trata de cerrar todas las demás apps o reiniciar tu
      dispositivo, y luego vuelve a unirte a la llamada. Eso debería liberar tu cámara para el uso.
    </p>
    <1>
      Tu cámara también puede estar bloqueada o deshabilitada. Para asegurarte de que tu dispositivo esté configurado
      para realizar una llamada exitosa, ve a nuestra <1>verificación simple del dispositivo antes de la llamada.</1>
    </1>`,

  CANT_HEAR_PROVIDER_HEADING: `No puedo escuchar a mi proveedor. ¿Qué debo hacer?`,
  CANT_HEAR_PROVIDER_CONTENT: `
    <p>
      Asegúrate de que el volumen de tu dispositivo esté alto y de que no tengas el sonido en modo silencio.
    </p>
    <p>
      Si tienes audífonos u otros altavoces conectados, verifica si el sonido se está reproduciendo allí.
    </p>
    <2>
      Si estás usando altavoces Bluetooth, primero verifica que tu dispositivo y los altavoces hayan sido enlazados.
      Si ya están enlazados, asegúrate de que Bluetooth esté activado en tu dispositivo. Para asegurarte de que tu
      dispositivo esté configurado para realizar una llamada exitosa, ve a nuestra <2>verificación simple del dispositivo
      antes de la llamada.</2>
    </2>`,

  PROVIDER_CANT_HEAR_ME_HEADING: `Mi proveedor no puede escucharme. ¿Qué debo hacer?`,
  PROVIDER_CANT_HEAR_ME_CONTENT: `
    <p>Revisa el sonido y el dispositivo:</p>
    <1>
      <0>Asegúrate de que el sonido no esté en modo silencio.</0>
      <1>
        <0>
          Si tienes un dispositivo Android y esta es tu primera llamada, deberás activar y
          desactivar el modo silencio al comienzo de la llamada. Tu navegador te mostrará una
          comprobación del permiso para la cámara y el micrófono. Después de dar ese permiso,
          estarás listo y no tendrás que volver a hacerlo.
        </0>
      </1>
      <2>Verifica que tu conexión a Internet esté funcionando.</2>
      <3>Si estás en un dispositivo móvil, asegúrate de estar conectado a WiFi.</3>
      <4>Ve si tu micrófono está bloqueado o deshabilitado e intenta habilitarlo.</4>
      <5>
        Si estás usando audífonos o auriculares, desconéctalos y usa los altavoces y el micrófono
        de tu dispositivo.
      </5>
      <6>Si estás utilizando un audífono Bluetooth, es posible que también debas desactivar el Bluetooth.</6>
    </1>
    <p>Si eso no solucionó el problema, trata de revisar tu dispositivo:</p>
    <3>
      <0>Cierra cualquier otra app. Cierra otras pestañas y ventanas del navegador.</0>
      <1>Pueden estar usando el micrófono. También pueden estar utilizando ancho de banda y memoria en tu dispositivo.</1>
      <2>Esto incluye aplicaciones no utilizadas, aplicaciones de fondo y aplicaciones de transmisión como Netflix o YouTube.</2>
      <3>Comprueba que tu navegador no está en modo privado o en una ventana de incógnito.</3>
      <4>Desactiva el modo de bajo consumo en dispositivos con batería. Pon a cargar el dispositivo para salir del modo de bajo consumo.</4>
      <5>Reinicia tu dispositivo para cerrar cualquier otra aplicación que esté usando energía.</5>
    </3>
    <p>Tu conexión a Internet también podría estar causando problemas. Intenta seguir estos pasos:</p>
    <5>
      <0>Si tienes una conexión WiFi, acércate al router.</0>
      <1>Si tu router está en un armario o lejos de tu dispositivo, intenta moverlo a una ubicación central en tu casa para tener una mejor recepción de la señal.</1>
      <2>También puedes cambiar a la frecuencia de 5GHz para aumentar el ancho de banda disponible para tu dispositivo.</2>
      <3>Otros dispositivos cerca de tu enrutador también podrían interrumpir tu señal.  Considera alejarlos más.</3>
      <4>Si otras personas también están usando Internet en tu casa, verifica si pueden dejar de hacerlo mientras realizas la llamada.</4>
      <5>Usa un cable de Ethernet para conectarte directamente a tu router, en lugar de usar WiFi, a fin de obtener una conexión más estable.</5>
      <6>Ponte en contacto con tu proveedor de servicios de Internet. Pueden ayudar a solucionar problemas y ofrecer diferentes opciones para una conexión más rápida si la intensidad de la señal es buena pero la velocidad es lenta.</6>
      <7>Debido al COVID-19, algunas compañías de Internet están ralentizando intencionalmente el tráfico de Internet durante las horas de alta demanda. Eso ayudará con los problemas de conexión mientras muchas personas están haciendo streaming de videos en casa. Si crees que esto te está pasando, solicita a tu proveedor de Internet que permita el tráfico normal a Athena.io porque lo estás usando para obtener atención médica.</7>
    </5>
    <p>Para asegurarte de que tu dispositivo esté configurado para realizar una llamada exitosa, ve a nuestra  <2> verificación simple del dispositivo antes de la llamada.</2>
  </p>`,

  I_GOT_DISCONNECTED_HEADING: `Comencé mi llamada pero me desconecté. ¿Qué debo hacer?`,
  I_GOT_DISCONNECTED_CONTENT: `<p>Si te desconectas, simplemente actualiza la página y vuelve a unirte a tu llamada.</p>`,
};
